// @ts-nocheck -- This file had typechecking errors that must be resolved by hand

import React from 'react';
import PropTypes from 'prop-types';
import cnames from 'classnames';
import RCTable from 'rc-table';
import styles from './styles.module.css';
import Text from '../Text';

const TH = ({ children, isBold = true, ...props }: any) => {
  return (
    <th {...props}>
      <Text type={isBold ? 'display5' : 'body'}>{ children }</Text>
    </th>
  );
};

const TD = ({ children, ...props }: any) => (
  <td {...props}>
    <Text>{ children }</Text>
  </td>
);

const Table = ({
  columns,
  rows,
  onRow,
  fixedFirstColumn,
  headingFirstColumn,
  rowKey,
}: any) => {
  const clickable = typeof onRow === 'function';

  const classNames = cnames(styles.table, {
    [styles.notFixed]: !fixedFirstColumn,
    [styles.clickable]: clickable,
  });

  return (
    <div className={classNames}>
      <RCTable
        onRow={onRow}
        style={{ width: '100%' }}
        scroll={fixedFirstColumn ? { x: true } : { x: false }}
        rowKey={rowKey}
        columns={columns.map((c?: any, i?: any) => ({
          ...(i === 0 && fixedFirstColumn ? { fixed: 'left' } : {}),
          dataIndex: c.dataIndex,
          title: c.title,
          width: c.width,
          align: c.align,
          onCell: c.onCell,
          onHeaderCell: c.onHeaderCell,
        }))}
        data={rows}
        components={{
          header: {
            cell: (props?: any) => <TH {...props} scope="col" />,
          },
          body: {
            row: ({ children, ...props }: any) => {
              return (
                <tr {...props}>
                  {React.Children.map(children, (child?: any, index?: any) => {
                    return React.cloneElement(child, {
                      component: index === 0 && headingFirstColumn ? (ownProps?: any) => <TH {...ownProps} scope="row" /> : TD,
                    });
                  })}
                </tr>
              );
            },
          },
        }}
      />
    </div>
  );
};

(Table as any).displayName = 'Table';

(Table as any).propTypes = {
  /**
    * Information about each column in the table
    */
  columns: PropTypes.arrayOf(PropTypes.shape({
    /**
      * The key of each row of data to show in this column
      */
    dataIndex: PropTypes.string.isRequired,
    /**
      * The human readable title displayed at the top of this column
      */
    title: PropTypes.string.isRequired,
    /**
      * The width of the column
      */
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    /**
      * The alignment of text in the column
      */
    align: PropTypes.oneOf(['left', 'right', 'center']),
    /**
      * Function to set custom props per each cell
      */
    onCell: PropTypes.func,
    /**
      * Function to set custom props per each header cell
      */
    onHeaderCell: PropTypes.func,
  })).isRequired,
  /**
    * Rows of data to be displayed in the table
    */
  rows: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  /**
    * For attaching events to table rows
    */
  onRow: PropTypes.func,
  /**
    * Which key of your data rows to use as the React key
    */
  rowKey: PropTypes.string.isRequired,
  /**
    * Whether or not to fix the first column in place as a contextual column
    */
  fixedFirstColumn: PropTypes.bool,
  /**
    * Whether or not to make the first column appear as headings
    */
  headingFirstColumn: PropTypes.bool,
};

(Table as any).defaultProps = {
  fixedFirstColumn: false,
  headingFirstColumn: false,
};

export default Table;
